import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0c592b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vertical-tab-layout" }
const _hoisted_2 = {
  class: "main-tab",
  ref: "tabs"
}
const _hoisted_3 = { class: "vertical-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex align-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "title title-selected"
}
const _hoisted_8 = {
  key: 2,
  class: "title"
}
const _hoisted_9 = { class: "flex align-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "expend",
  src: "/ico/expend.svg"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "tab-container grow" }
const _hoisted_13 = {
  key: 0,
  class: "tab-container-main"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!_ctx.hiddenTabs.includes(tab))
              ? (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(
              index == _ctx.selectedIndex ? 'tab-button selected' : 'tab-button'
            ),
                  key: tab,
                  onClick: ($event: any) => (_ctx.changeTab(tab))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.icons != undefined)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: _normalizeClass(index == _ctx.selectedIndex ? 'img-filter' : ''),
                          src: _ctx.icons[index]
                        }, null, 10, _hoisted_6))
                      : _createCommentVNode("", true),
                    (index == _ctx.selectedIndex)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.labels[index]), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.labels[index]), 1))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, 'tail' + index, {}, undefined, true)
                  ])
                ], 10, _hoisted_4))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expend && _ctx.expend(...args))),
        class: "flex col grow h100 no-pc align-center justify-center"
      }, _hoisted_11)
    ], 512),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: tab }, [
          (index == _ctx.selectedIndex)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _renderSlot(_ctx.$slots, _ctx.selectedIndex, {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}